import script from "./person.vue?vue&type=script&setup=true&lang=js"
export * from "./person.vue?vue&type=script&setup=true&lang=js"

import "./person.vue?vue&type=style&index=0&id=31733b96&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31733b96"]])

export default __exports__